import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scratchFilter',
  pure: true
})
export class PlanScratchFilterPipe implements PipeTransform {
  transform(planList: any, args?: any): any {
    return planList.filter(e => e.name != '').length;
  }
}